{
  "it": {
    "constants": {
      "address": {
        "city": "Città",
        "country": "Paese",
        "number": "Numero",
        "street": "Via",
        "zip": "CAP"
      },
      "crud": {
        "created_at": "Creato il",
        "deleted_at": "Eliminato il",
        "updated_at": "Aggiornato il"
      },
      "currencies": {
        "all": "Tutte le valute",
        "popular": "Popolari"
      },
      "days": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      "languages": {
        "de": "Tedesco",
        "el": "Greco",
        "en": "Inglese",
        "es": "Spagnolo",
        "fallback_info": "Sembra che questo non sia disponibile nella Sua lingua. Utilizziamo invece la traduzione esistente in {fallback_locale}.",
        "fr": "Francese",
        "it": "Italiano",
        "nl": "Olandese",
        "pl": "Polacco",
        "pt": "Portoghese"
      },
      "languages_short": {
        "de": "DE",
        "el": "EL",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperiale",
        "metric": "Metrico",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
      ],
      "profile_statuses": {
        "active": "Attivo",
        "added": "Non ancora invitato",
        "blocked": "Disattivato",
        "discarded": "Eliminato",
        "invited": "Invitato",
        "invited_at": "Invitato"
      },
      "profile_statuses_descriptive": {
        "active": "Ultima volta attivo sulla piattaforma: {session_ended_at}",
        "added": "Non ancora invitato",
        "blocked": "Disattivato",
        "discarded": "Eliminato",
        "invited": "Invitato ma non ancora registrato",
        "invited_at": "Invitato il {invited_at}. Non ancora registrato"
      },
      "profile_titles": {
        "dr": "Dottore",
        "mr": "Signore",
        "mrs": "Signora",
        "professor": "Professore",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Giorni",
        "months": "Mesi",
        "weeks": "Settimane"
      },
      "time_units_count": {
        "days": "nessun giorno | giorno | giorni",
        "months": "nessun mese | mese | mesi",
        "weeks": "nessuna settimana | settimana | settimane"
      },
      "timezone_regions": {
        "Africa": "Africa",
        "America": "America",
        "Asia": "Asia",
        "Atlantic": "Atlantico",
        "Australia": "Australia",
        "Europe": "Europa",
        "Pacific": "Pacifico"
      },
      "timezones": {
        "Africa/Abidjan": "Africa/Abidjan",
        "Africa/Cairo": "Africa/Il Cairo",
        "Africa/Casablanca": "Africa/Casablanca",
        "Africa/Johannesburg": "Africa/Johannesburg",
        "Africa/Lagos": "Africa/Lagos",
        "Africa/Nairobi": "Africa/Nairobi",
        "America/Anchorage": "America/Anchorage",
        "America/Bogota": "America/Bogotà",
        "America/Buenos_Aires": "America/Buenos Aires",
        "America/Chicago": "America/Chicago",
        "America/Denver": "America/Denver",
        "America/Halifax": "America/Halifax",
        "America/Lima": "America/Lima",
        "America/Los_Angeles": "America/Los Angeles",
        "America/Mexico_City": "America/Città del Messico",
        "America/New_York": "America/New York",
        "America/Phoenix": "America/Phoenix",
        "America/Santiago": "America/Santiago",
        "America/Sao_Paulo": "America/San Paolo",
        "America/St_Johns": "America/St. John's",
        "America/Toronto": "America/Toronto",
        "America/Vancouver": "America/Vancouver",
        "Asia/Bangkok": "Asia/Bangkok",
        "Asia/Colombo": "Asia/Colombo",
        "Asia/Dhaka": "Asia/Dacca",
        "Asia/Dubai": "Asia/Dubai",
        "Asia/Ho_Chi_Minh": "Asia/Ho Chi Minh",
        "Asia/Hong_Kong": "Asia/Hong Kong",
        "Asia/Jakarta": "Asia/Giacarta",
        "Asia/Karachi": "Asia/Karachi",
        "Asia/Kolkata": "Asia/Calcutta",
        "Asia/Kuala_Lumpur": "Asia/Kuala Lumpur",
        "Asia/Makassar": "Asia/Makassar",
        "Asia/Manila": "Asia/Manila",
        "Asia/Riyadh": "Asia/Riad",
        "Asia/Seoul": "Asia/Seul",
        "Asia/Shanghai": "Asia/Shanghai",
        "Asia/Singapore": "Asia/Singapore",
        "Asia/Taipei": "Asia/Taipei",
        "Asia/Tehran": "Asia/Teheran",
        "Asia/Tokyo": "Asia/Tokyo",
        "Atlantic/Reykjavik": "Atlantico/Reykjavik",
        "Australia/Adelaide": "Australia/Adelaide",
        "Australia/Brisbane": "Australia/Brisbane",
        "Australia/Darwin": "Australia/Darwin",
        "Australia/Hobart": "Australia/Hobart",
        "Australia/Melbourne": "Australia/Melbourne",
        "Australia/Perth": "Australia/Perth",
        "Australia/Sydney": "Australia/Sydney",
        "Europe/Amsterdam": "Europa/Amsterdam",
        "Europe/Athens": "Europa/Atene",
        "Europe/Belgrade": "Europa/Belgrado",
        "Europe/Berlin": "Europa/Berlino",
        "Europe/Brussels": "Europa/Bruxelles",
        "Europe/Bucharest": "Europa/Bucarest",
        "Europe/Budapest": "Europa/Budapest",
        "Europe/Copenhagen": "Europa/Copenaghen",
        "Europe/Dublin": "Europa/Dublino",
        "Europe/Helsinki": "Europa/Helsinki",
        "Europe/Istanbul": "Europa/Istanbul",
        "Europe/Lisbon": "Europa/Lisbona",
        "Europe/London": "Europa/Londra",
        "Europe/Madrid": "Europa/Madrid",
        "Europe/Moscow": "Europa/Mosca",
        "Europe/Oslo": "Europa/Oslo",
        "Europe/Paris": "Europa/Parigi",
        "Europe/Prague": "Europa/Praga",
        "Europe/Rome": "Europa/Roma",
        "Europe/Stockholm": "Europa/Stoccolma",
        "Europe/Vienna": "Europa/Vienna",
        "Europe/Warsaw": "Europa/Varsavia",
        "Europe/Zurich": "Europa/Zurigo",
        "Pacific/Auckland": "Pacifico/Auckland",
        "Pacific/Fiji": "Pacifico/Figi",
        "Pacific/Honolulu": "Pacifico/Honolulu"
      },
      "wind_orientations": {
        "east": "Est",
        "north": "Nord",
        "northeast": "Nord-Est",
        "northwest": "Nord-Ovest",
        "select": "Selezioni l'orientamento",
        "south": "Sud",
        "southeast": "Sud-Est",
        "southwest": "Sud-Ovest",
        "west": "Ovest"
      }
    }
  }
}
